// extracted by mini-css-extract-plugin
module.exports =  {"container":"_32bbee5fda--container--g7MOX","seo-block":"_32bbee5fda--seo-block--uwleI","title":"_32bbee5fda--title--qfPTk","link":"_32bbee5fda--link--TdeRx"};